import { render, staticRenderFns } from "./LoadingError.vue?vue&type=template&id=05732a10&scoped=true"
import script from "./LoadingError.vue?vue&type=script&lang=ts"
export * from "./LoadingError.vue?vue&type=script&lang=ts"
import style0 from "./LoadingError.vue?vue&type=style&index=0&id=05732a10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05732a10",
  null
  
)

export default component.exports